const Colors = {
  PRIMARY: "#40D78F",
  RED: "#FF5764",
  ORANGE: "#FFA134",
  LIGHTBLUE: "#35B1FF",
  PURPLE: "#6D78FF",
  GREEN: "#40D78F",
  YELLOW: "#FFE34F",
  PINK: "#FF4D97",
  BLUE: "#1035F1",
  WHITE: "#FFFFFF",

  TEXT: "#333333",
  TEXT_HALF_OPACITY: "#33333380",
  SEPARATOR: "#F1F1F1",
  GRAY: "#CFCFCF",
  PLACEHOLDERS: "#BBBBBB",
  ACHIEVEMENTS_GRAY: "#ABABAB",
  CAPTION_GRAY: "#686868",
  BACKGROUND_GRAY: "#626262",
  LIGHT_GRAY: "#E9E9E9",
  BLACK: "#373737",

  DARKER_BACKGROUND: "#F5F5F6",
  DARKER_PURPLE: "#535CCF",
  DARKER_ORANGE: "#E1861C",
  DARKER_LIGHTBLUE: "#008AE0",
  DARKER_PINK: "#DD2B75",
  ICON_BACKGROUND_VIOLET: "#C0C5FF",
  ICON_BACKGROUND_ORANGE: "#FFDDB6",
  ICON_BACKGROUND_GREEN: "#bcffc0",
  ICON_BACKGROUND_RED: "#FFBCC1",
  ICON_BACKGROUND_LIGHTBLUE: "#ADE0FF",
  ICON_BACKGROUND_PINK: "#FF7FCA",

  GENIALLY_WHITE: "#FAF4EC",

  PURPLE_BUTTON: "#57219B",

  // colores del nuevo look and feel
  CARD_BACKGROUND_LIGHT_PURPLE: "#cbbfff",
  CARD_ICON_LIGHT_PURPLE: "#b4a4ff",
  CARD_BACKGROUND_APPLE_GREEN: "#d3e480",
  CARD_ICON_APPLE_GREEN: "#a7d766",
  CARD_BACKGROUND_DARK_ORANGE: "#ef6c35",
  CARD_ICON_DARK_ORANGE: "#aa745c",
  CARD_BACKGROUND_LIGHT_GRAY: "#f8f8f8",
  
  // Colores adicionales para las tarjetas de engagement
  CARD_BACKGROUND_LIGHT_PINK: "#ffb3d9",
  CARD_ICON_LIGHT_PINK: "#ff80c4",
  CARD_BACKGROUND_LIGHT_ORANGE: "#ffd6b3",
  CARD_ICON_LIGHT_ORANGE: "#ffb366",
  CARD_BACKGROUND_LIGHT_BLUE: "#b3d9ff",
  CARD_ICON_LIGHT_BLUE: "#80bfff",
  CARD_BACKGROUND_LIGHT_RED: "#ffb3b3",
  CARD_ICON_LIGHT_RED: "#ff8080",
};

export default Colors;
